import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { AbstractTuiControl } from '@taiga-ui/legacy';
import { isArray } from 'lodash-es';
import { EnvService } from '@src/app/modules/env';
import { APP_CONFIG } from '@src/core';

import { FileType, InputFilesSize } from './types';

@Component({
  selector: 'app-input-files',
  templateUrl: './input-files.component.html',
  styleUrls: ['./input-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputFilesComponent extends AbstractTuiControl<FileType | readonly FileType[] | null> implements OnInit {
  private readonly env = inject(EnvService);

  @Input() accept = '';
  /** Взаимодействие с камерой (для мобилок) */
  @Input() capture: null | 'environment' | 'user' = null;
  @Input() multiple = false;
  @Input() loading = false;
  @Input() showDelete = true;
  @Input() isModeration = false;
  @Input() contentTemplate?: TemplateRef<any>;

  @Input() size: InputFilesSize = 'm';
  @Input() maxFileSize: number = APP_CONFIG.fileSizeMax.doc;
  @Input() label?: string;
  @Input() link?: string;

  @Output() rejectedFiles = new EventEmitter<FileType[]>();
  @Output() removed = new EventEmitter<void>();

  rejectedFilesControl = new FormControl<Array<FileType>>([], { nonNullable: true });
  get arrayRejectedFiles(): FileType[] {
    return this.rejectedFilesControl.value ?? [];
  }

  get arrayFiles(): FileType[] {
    return this.value ? (this.multiple ? (this.value as FileType[]) : ([this.value] as FileType[])) : [];
  }

  get focused(): boolean {
    return false;
  }

  protected getFallbackValue(): FileType | readonly FileType[] | null {
    return null;
  }

  ngOnInit(): void {
    this.rejectedFilesControl.valueChanges.subscribe(rejectedFiles => this.rejectedFiles.emit(rejectedFiles));
  }

  valueChange(files: FileType | FileType[]): void {
    if (isArray(files)) {
      this.control?.setValue(files.filter(file => !this.arrayRejectedFiles.includes(file)));
    } else if (!!this.arrayRejectedFiles.includes(files)) {
      this.control?.reset();
    } else {
      this.control?.setValue(files);
    }
  }

  rejectFile(files: FileType | readonly FileType[]): void {
    this.rejectedFilesControl?.setValue([
      ...this.arrayRejectedFiles,
      ...(isArray(files) ? (files as FileType[]) : [files as FileType]),
    ]);
  }

  removeFile(file: FileType): void {
    if (this.multiple) {
      this.control?.setValue((this.value as FileType[])?.filter((current: FileType) => current !== file) ?? []);
    } else {
      this.control?.reset();
    }
    this.removed.emit();
    this.cdr.markForCheck();
  }

  removeRejectedFile({ name }: FileType): void {
    this.rejectedFilesControl?.setValue(this.arrayRejectedFiles.filter(rejected => rejected.name !== name));
    this.cdr.markForCheck();
  }

  removeAllFiles() {
    this.control?.reset();
    this.rejectedFilesControl?.reset();
    this.cdr.markForCheck();
  }
}
